const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-5 mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
        {/* Branding line */}
        <div className="flex items-center justify-center">
          <div className="flex items-center gap-2 group">
            <div className="w-7 h-7 bg-gradient-to-br from-red-700 to-red-900 text-white rounded-md flex items-center justify-center font-black text-[10px] tracking-tight shadow-sm">
              UA
            </div>
            <p className="text-[11px] font-bold tracking-[0.25em] text-gray-700 uppercase">
              Powered by <span className="text-red-700">Underads</span>
            </p>
          </div>
        </div>

        {/* Meta line */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-1.5 pt-3 border-t border-gray-100">
          <p className="text-[11px] text-gray-500">
            UA Syarikat • Sistem Pengurusan Kewangan & HR
          </p>
          <p className="text-[11px] text-gray-400">
            © {new Date().getFullYear()} Underads Sdn Bhd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
